module.exports = __webpack_public_path__ + "static/media/07_1.e697a41d.png";